import alt from "../alt";
import indexBy from "lodash/keyBy";
import extend from "lodash/extend";
import ExternalSyncUtil from "../utils/ExternalSyncUtil";
import ExternalSyncActions from "../actions/ExternalSyncActions";
import EventBucketActions from "../actions/EventBucketActions";
import UserStore from "../stores/UserStore";

class ExternalSyncStore {
  constructor() {
    this.bindActions(ExternalSyncActions);

    this.state = {
      providerStatus: {},
      externalSyncs: {},
      mailchimpSegments: {},
      newExternalSyncId: null,
      isEditing: false,
      errorMessage: "",
      isFetching: false,
      isFetchingProviderStatus: false,
      hasFetchedProviderStatus: false
    };

    this.exportPublicMethods({
      getExternalSyncById: this.getExternalSyncById.bind(this)
    });
  }

  getExternalSyncById(id) {
    return this.state.externalSyncs[id];
  }

  onClearErrors() {
    this.setState({
      errorMessage: ""
    });
  }

  onFetchProviderStatus() {
    this.setState({ isFetchingProviderStatus: true });
    ExternalSyncUtil.getProviderStatus(UserStore.getState().apiKey)
      .then(data => {
        this.setState({
          hasFetchedProviderStatus: true,
          isFetchingProviderStatus: false,
          providerStatus: data
        });
      })
      .catch(ExternalSyncActions.fetchFailed);
  }

  onFetchMailchimpSegments(list) {
    ExternalSyncUtil.getMailchimpSegmentsForList(
      UserStore.getState().apiKey,
      list
    )
      .then(data => {
        const mailchimpSegments = Object.assign(
          {},
          this.state.mailchimpSegments,
          {
            [list]: data.segments
          }
        );
        this.setState({ mailchimpSegments });
      })
      .catch(ExternalSyncActions.fetchFailed);
  }

  onFetchOne(id) {
    ExternalSyncUtil.fetchOne(UserStore.getState().apiKey, id)
      .then(data => {
        ExternalSyncActions.updateExternalSync(id, data);
      })
      .catch(ExternalSyncActions.fetchFailed);
  }

  onFetchAllForBucket(eventBucket) {
    this.setState({ isFetching: true });
    ExternalSyncUtil.fetchAllForBucket(UserStore.getState().apiKey, eventBucket)
      .then(data => {
        ExternalSyncActions.updateExternalSyncs(indexBy(data, "id"));
        this.setState({ isFetching: false });
      })
      .catch(ExternalSyncActions.fetchFailed);
  }

  onEdit(newData) {
    this.setState({ errorMessage: "", isEditing: true });
    ExternalSyncUtil.edit(
      UserStore.getState().apiKey,
      newData.id,
      newData.values
    )
      .then(data => {
        ExternalSyncActions.updateExternalSync(newData.id, data);
        EventBucketActions.fetchOne(data.event_bucket);
      })
      .catch(ExternalSyncActions.editFailed);
  }

  onDelete(id) {
    ExternalSyncUtil.delete(UserStore.getState().apiKey, id)
      .then(data => {
        EventBucketActions.fetchOne(this.state.externalSyncs[id].event_bucket);
        ExternalSyncActions.updateExternalSync(id, undefined);
      })
      .catch(ExternalSyncActions.editFailed);
  }

  onForceSync(id) {
    this.setState({ errorMessage: "", isEditing: true });
    ExternalSyncUtil.forceSync(UserStore.getState().apiKey, id)
      .then(data => {
        ExternalSyncActions.updateExternalSync(id, data);
      })
      .catch(ExternalSyncActions.editFailed);
  }

  onCreate(newData) {
    this.setState({
      newExternalSyncId: null
    });

    ExternalSyncUtil.create(UserStore.getState().apiKey, newData)
      .then(data => {
        window.Intercom("trackEvent", "create-externalsync");

        ExternalSyncActions.updateExternalSync(data.id, data);
        EventBucketActions.fetchOne(data.event_bucket);
        this.setState({
          newExternalSyncId: data.id
        });
      })
      .catch(ExternalSyncActions.fetchFailed);
  }

  onUpdateExternalSync(data) {
    if (!data.externalSync) {
      delete this.state.externalSyncs[data.id];
    } else {
      this.state.externalSyncs[data.id] = data.externalSync;
    }
    this.state.isEditing = false;
    this.state.newExternalSyncId = null;
    this.setState(this.state);
  }

  onUpdateExternalSyncs(externalSyncs) {
    extend(this.state.externalSyncs, externalSyncs);
    this.setState(this.state);
  }

  onFetchFailed(e) {
    alert(`Fetching external sync failed: ${e.message}`);
    throw e;
  }

  onEditFailed(e) {
    this.setState({
      errorMessage: e.message,
      isEditing: false
    });
  }
}

export default alt.createStore(ExternalSyncStore, "ExternalSyncStore");



// WEBPACK FOOTER //
// ./src/app/stores/ExternalSyncStore.js